import { toArray } from 'lodash'
import { mapLanguage } from 'Lib/i18nMiddleware'
import { SET_LANGUAGE } from './config'

export const CATEGORIES_FETCH_LIST_REQUEST = 'CATEGORIES::FETCH_LIST_REQUEST'
export const CATEGORIES_FETCH_LIST_FAIL = 'CATEGORIES::FETCH_LIST_FAIL'
export const CATEGORIES_FETCH_LIST_SUCCESS = 'CATEGORIES::FETCH_LIST_SUCCESS'

const initialState = { list: [], default: [], fetching: false }

export const fetchCategoryList = () => ({
  type: CATEGORIES_FETCH_LIST_REQUEST,
  entity: 'categories',
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORIES_FETCH_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case CATEGORIES_FETCH_LIST_SUCCESS: {
      return {
        ...state,
        list: toArray(action.data).map(mapLanguage(action.lang)),
        default: toArray(action.data),
        fetching: false,
      }
    }
    case CATEGORIES_FETCH_LIST_FAIL: {
      return {
        ...state,
        list: [],
        fetching: false,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        list: state.default.map(mapLanguage(action.payload.lang)),
      }
    }
    default:
      return state
  }
}

export default reducer
